var AllResolver_1;
import * as tslib_1 from "tslib";
/**
 * The MIT License (MIT)
 * https://github.com/aurelia/dependency-injection
 *
 * Copyright (c) 2010 - 2018 Blue Spire Inc.
 */
import { containerResolver } from '../protocol/resolver';
/**
 * Used to allow functions/classes to specify resolution of all matches to a key.
 */
let AllResolver = AllResolver_1 = class AllResolver {
    /**
     * Creates an instance of the All class.
     * @param key The key to lazily resolve all matches for.
     */
    constructor(key) {
        this._key = key;
    }
    /**
     * Creates an All Resolver for the supplied key.
     * @param key The key to resolve all instances for.
     * @return Returns an instance of All for the key.
     */
    static of(key) {
        return new AllResolver_1(key);
    }
    /**
     * Called by the container to resolve all matching dependencies as an array of instances.
     * @param container The container to resolve from.
     * @return Returns an array of all matching instances.
     */
    get(container, key) {
        return container.getAll(this._key);
    }
};
AllResolver = AllResolver_1 = tslib_1.__decorate([
    containerResolver,
    tslib_1.__metadata("design:paramtypes", [Object])
], AllResolver);
export { AllResolver };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQWxsUmVzb2x2ZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJBbGxSZXNvbHZlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBOzs7OztHQUtHO0FBQ0gsT0FBTyxFQUFFLGlCQUFpQixFQUFFLE1BQU0sc0JBQXNCLENBQUM7QUFJekQ7O0dBRUc7QUFFSCxJQUFhLFdBQVcsbUJBQXhCLE1BQWEsV0FBVztJQWFwQjs7O09BR0c7SUFDSCxZQUFtQixHQUFXO1FBQzFCLElBQUksQ0FBQyxJQUFJLEdBQUcsR0FBRyxDQUFDO0lBQ3BCLENBQUM7SUFsQkQ7Ozs7T0FJRztJQUNJLE1BQU0sQ0FBQyxFQUFFLENBQUksR0FBVztRQUMzQixPQUFPLElBQUksYUFBVyxDQUFJLEdBQUcsQ0FBQyxDQUFDO0lBQ25DLENBQUM7SUFhRDs7OztPQUlHO0lBQ0ksR0FBRyxDQUFDLFNBQW9CLEVBQUUsR0FBVztRQUN4QyxPQUFPLFNBQVMsQ0FBQyxNQUFNLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxDQUFDO0lBQ3ZDLENBQUM7Q0FDSixDQUFBO0FBN0JZLFdBQVc7SUFEdkIsaUJBQWlCOztHQUNMLFdBQVcsQ0E2QnZCO1NBN0JZLFdBQVcifQ==